import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@ontruck/orc';
import useFormState from 'hooks/useFormState';

const DAYS_ARRAY = ['1', '2', '3', '4', '5', '6', '7']; // Array.from(Array(7).keys()).map(item => item + 1)

const DaySelector = ({ day, checked, label, setDay }) => {
  const handleSetDay = () => setDay({ day });

  return (
    <Checkbox
      name={day}
      label={label}
      size="L"
      onChange={handleSetDay}
      checked={checked}
    />
  );
};

const WeekDaysSelector = ({ className, t, days, setDay, hasError }) => {
  const field = 'day_checkbox';
  const stopId = 'recurring';
  const { fieldHasError } = useFormState(stopId, field, days.length);
  const error = !!fieldHasError || hasError ? 'error' : '';

  return (
    <div className={`${className}`}>
      <p>{t('form.range_days')}</p>
      <div className={`days-container ${error}`}>
        <div className="days-center">
          {DAYS_ARRAY.map((day) => (
            <DaySelector
              key={day}
              day={day}
              label={t(`weekdays_singular.${day}`)}
              days={days}
              checked={(days || []).indexOf(String(day)) >= 0}
              setDay={setDay}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

WeekDaysSelector.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
  days: PropTypes.arrayOf(PropTypes.number),
  setDay: PropTypes.func,
  hasError: PropTypes.bool,
};

WeekDaysSelector.defaultProps = {
  className: '',
  t: (t) => t,
  days: [],
  setDay: () => ({}),
  hasError: false,
};

DaySelector.propTypes = {
  setDay: PropTypes.func,
  day: PropTypes.number.isRequired,
  label: PropTypes.string,
  checked: PropTypes.bool,
};

DaySelector.defaultProps = {
  setDay: () => ({}),
  label: '',
  checked: false,
};

export default WeekDaysSelector;
